import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={26}
    viewBox="0 0 23 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#444697'}
      fillRule="evenodd"
      d="M6.16 22.93c-1.61 0-2.91-1.3-2.91-2.91V6.36c0-1.61 1.3-2.91 2.91-2.91h5.67a1.25 1.25 0 0 0 0-2.5H6.16C3.18.95.76 3.37.76 6.35v13.66c0 2.98 2.42 5.4 5.4 5.4h5.67a1.25 1.25 0 0 0 0-2.5H6.16v.02Zm9.2-4.28c.49.49 1.28.49 1.76 0l4.58-4.58c.23-.23.36-.55.36-.88 0-.33-.13-.65-.36-.88l-4.58-4.58c-.49-.49-1.28-.49-1.76 0-.49.49-.49 1.27 0 1.76l2.46 2.46H8.89a1.25 1.25 0 0 0 0 2.5h8.93l-2.46 2.46c-.49.49-.49 1.27 0 1.76v-.02Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
